import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import HomePage from './components/HomePage';
import MicrositePage from './components/MicrositePage';
import LoginPage from './components/LoginPage';
import AdminPage from './components/AdminPage';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/microsite" element={
          <AuthenticatedTemplate>
            <MicrositePage />
          </AuthenticatedTemplate>
        } />
        <Route path="/admin" element={
          <>
            <UnauthenticatedTemplate>
              <LoginPage />
            </UnauthenticatedTemplate>
            <AuthenticatedTemplate>
              <AdminPage />
            </AuthenticatedTemplate>
          </>
        } />
      </Routes>
    </div>
  );
}

export default App;